import React from 'react'
import { observer } from 'mobx-react'

import Header from '~/components/MainHeader'
import Footer from '~/components/Footer'
import Landing from './Landing'
import DivorceLoader from './DivorceLoader'
import { REQUEST_STATUSES } from '~/utilities/constants'
import useInject from '~/hooks/useInject'

const mapStore = (store) => ({
  isMobile: store.ui.isMobile,
  fetcherStatus: store.divorceLookup.fetcherStatus,
})

const Layout = () => {
  const { fetcherStatus, isMobile } = useInject(mapStore)

  return (
    <>
      <Header isMobile={isMobile} noHamburger fetcherType="divorce" />

      {fetcherStatus === REQUEST_STATUSES.loading ? <DivorceLoader /> : <Landing />}

      <Footer />
    </>
  )
}

export default observer(Layout)
